import { useCallback, useState } from 'react';
import { useNotification } from '@/hooks';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { getErrorMessage } from '@/utils';
import { useSendOrResendDriverLogisticOperatorOtpMutation } from '../services';

const useAssignDriverLogisticOperatorOtp = () => {
    const { showNotification } = useNotification();
    const [sendOrResendOtp, { isLoading }] = useSendOrResendDriverLogisticOperatorOtpMutation();
    const [otpSent, setOtpSent] = useState(false);

    const handleSendOrResend = useCallback(
        async (driverId: string, logisticOperatorId: string, isResend: boolean) => {
            if (!driverId || !logisticOperatorId) {
                showNotification(
                    isResend
                        ? 'Selecciona un operador logístico antes de reenviar'
                        : 'Selecciona un operador logístico antes de asignar',
                    NotificationSeverity.warning
                );
                return false;
            }

            try {
                await sendOrResendOtp({ driverId, logisticOperatorId }).unwrap();
                setOtpSent(true);
                showNotification(
                    isResend ? 'Código reenviado al conductor' : 'Código enviado al conductor',
                    NotificationSeverity.success
                );
                return true;
            } catch (error) {
                const defaultMessage = isResend
                    ? 'Error al reenviar el código'
                    : 'Error al asignar operador logístico';
                const errorMessage = getErrorMessage(error, defaultMessage);
                showNotification(errorMessage, NotificationSeverity.error);
                return false;
            }
        },
        [sendOrResendOtp, showNotification]
    );

    const handleAssignOperator = useCallback(
        async (driverId: string, logisticOperatorId: string) => {
            return handleSendOrResend(driverId, logisticOperatorId, false);
        },
        [handleSendOrResend]
    );

    const handleResendOtp = useCallback(
        async (driverId: string, logisticOperatorId: string) => {
            return handleSendOrResend(driverId, logisticOperatorId, true);
        },
        [handleSendOrResend]
    );

    return {
        handleAssignOperator,
        handleResendOtp,
        isLoading,
        isResending: isLoading,
        otpSent,
    };
};

export default useAssignDriverLogisticOperatorOtp;
